import { render, staticRenderFns } from "./recoverPassword.vue?vue&type=template&id=6cb29cae"
import script from "./recoverPassword.vue?vue&type=script&lang=js"
export * from "./recoverPassword.vue?vue&type=script&lang=js"
import style0 from "./recoverPassword.vue?vue&type=style&index=0&id=6cb29cae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports